// extracted by mini-css-extract-plugin
export default {"mime-type-indicator":"mime-type-indicator--BJnDc+jsOT","mimeTypeIndicator":"mime-type-indicator--BJnDc+jsOT"};